import axios from 'axios'

export default{
    namespaced: true,
    state: {
        reportTerms: [],        
    },
    getters: {
        getReportTerms(state){
            return state.reportTerms
        },        
    },
    mutations: {
        setReportTerms(state, value){
            state.reportTerms = value
        }
    },
    actions: {
        getAcademicTerms(contex, payload){
            let url = '/api/student-reports/' + payload.id;
            return axios.get(url);
            
        }
    }
}